import styled from 'styled-components'

const Lista = styled.ul`
  margin: 0 16px 0 0;
  padding: 0;
  display: flex;
  justify-content: space-around;
  li {
    display: inline;
    a {
      border: 1px #d0d0d0 solid;
      border-radius: 50px;
      display: block;
      padding: 4px;
      margin: 5px;
      max-height: 14px;
      color: #148581;
      :hover {
        background: #148581;
        color: #ffffff;
        border: 1px #148581 solid;
      }
    }
    span {
      text-indent: -9999px;
      display: block;
    }
  }
`
export default Lista
